import { Injectable } from '@angular/core';
import { resetFormDirtyStatus, setFormDirtyStatus } from '@app/core/leave-page-handler/actions/leave-page';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MarkAsDirtyAction, MarkAsSubmittedAction, MarkAsUnsubmittedAction, SetValueAction } from 'ngrx-forms';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class PcsNgRxFormsEffects {

  pcsNgRxFormDirty$ = createEffect(() => this.actions$.pipe(
    ofType(MarkAsDirtyAction.TYPE, SetValueAction.TYPE),
    switchMap(() => of(setFormDirtyStatus()))
  ));

  pcsNgRxFormSubmitted$ = createEffect(() => this.actions$.pipe(
    ofType(MarkAsSubmittedAction.TYPE),
    switchMap(({controlId}: any) => [
      resetFormDirtyStatus(),
      new MarkAsUnsubmittedAction(controlId)
    ])
  ));

  constructor(
    private actions$: Actions
  ) {
  }
}
